import {
  HiOutlineChatBubbleLeftRight,
  HiOutlineBookOpen,
  HiOutlineQuestionMarkCircle,
} from "react-icons/hi2";

import { CustomModal } from "../shared";
import { cn } from "../../lib/cn";

const SUPPORT_OPTIONS = [
  {
    key: "faq",
    title: "Browse the FAQ",
    description: "Find quick answers to common questions.",
    icon: HiOutlineBookOpen,
  },
  {
    key: "SUPPORT_REQUEST",
    title: "Contact support",
    description: "Tell us what is not working and request help.",
    icon: HiOutlineChatBubbleLeftRight,
  },
  {
    key: "FEEDBACK",
    title: "Share feedback",
    description: "Share feedback or suggest an improvement to help us make DealNest better.",
    icon: HiOutlineQuestionMarkCircle,
  },
];

export const HelpSupportOptionsModal = ({ open, onClose, onSelect }) => (
  <CustomModal
    title="Help & Support"
    open={open}
    close={onClose}
    showPrimaryButton={false}
    showSecondaryButton={false}
    showCloseButton={false}
    showHeaderCancelButton
    dialogSize="default"
  >
    <div data-support-modal="true" className="space-y-4">
      <p className="text-sm leading-6 text-mediumgrey">
        Choose an option without leaving the page you are working on.
      </p>
      <div className="grid gap-3 sm:grid-cols-3">
        {SUPPORT_OPTIONS.map(({ key, title, description, icon: Icon }) => (
          <button
            key={key}
            type="button"
            onClick={() => onSelect(key)}
            className={cn(
              "flex min-h-32 flex-col items-start rounded-xl border border-surface-border bg-white p-4 text-left transition",
              "hover:border-primary/40 hover:bg-surface/70 hover:shadow-sm",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary/60 focus-visible:ring-offset-2",
            )}
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-surface-hover text-primary">
              <Icon className="h-5 w-5" aria-hidden="true" />
            </span>
            <span className="mt-3 text-sm font-semibold text-primary">{title}</span>
            <span className="mt-1 text-xs leading-5 text-mediumgrey">{description}</span>
          </button>
        ))}
      </div>
    </div>
  </CustomModal>
);
